import { render, staticRenderFns } from "./SignatureModalConfig.vue?vue&type=template&id=626ada91&scoped=true&"
import script from "./SignatureModalConfig.vue?vue&type=script&lang=js&"
export * from "./SignatureModalConfig.vue?vue&type=script&lang=js&"
import style0 from "./SignatureModalConfig.vue?vue&type=style&index=0&id=626ada91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ada91",
  null
  
)

export default component.exports